<script>
export const pageName = 'rockets-view';
export const pageRoute = '/rockets/{id}';
export const title = 'View Rocket'
export const requireMembership = true;

import { hideLoading, showLoading } from '../../js/utils/loading.js';
import { navigate } from '@trullock/page-manager'
import { commands } from '../../js/lib/functions.js';
import { showToast } from '../../js/utils/toast.js'
import RocketView from '../../../functions/domain/rockets/rocketView.js';
import UserView from '../../../functions/domain/users/userView.js';
import { getCurrentUserId } from '../../js/auth.js';
import { showConfirm } from '../../js/utils/confirm.js';
import { getMapTasks } from '../../js/utils/map.js';
import MapFlightCardUrl from '../../resources/MAP-and-Record-flight-card-A4-v3-1.pdf'
import CertFlightCardUrl from '../../resources/Cert-and-Record-flight-card-A4-v3-1.pdf'
import { attemptTypeToFullAttempt, motorsToString } from '../../../functions/domain/certification-utils.js';
import { listenToProjection } from '@trullock/firebase-client';

export default {
	data() {
		return { 
			rocket: null,
			MapFlightCardUrl,
			CertFlightCardUrl,
			flights: [],
			ready: false
		}
	},

	methods: {
		attemptTypeToFullAttempt,
		motorsToString,
		async boot(opts) {
			
			this.unsub = await listenToProjection([UserView, getCurrentUserId(), RocketView, opts.id], async rocket => {
				this.rocket = rocket
				this.flights = rocket.flights;
				await Promise.all(this.flights.map(async f => {
					f.mapTasks = await getMapTasks(f.mapTasks);
				}))
				this.flights.sort((a, b) => b.flownOn - a.flownOn);
			});
			this.ready = true;
		},
		deleteRocket() {
			commands.warmUp();

			showConfirm({
				title: 'Confirm deletion',
				message: `Are you sure you want to delete this rocket and all its associated flights?`,
				buttons: [
					{
						text: 'Cancel',
						style: 'white'
					},
					{
						text: 'Delete rocket',
						style: 'danger',
						action: async () => {
							this.unsub();

							let result = await commands.rockets.delete({ rocketId: this.rocket.id })
							if(!result.success)
							{
								showToast({ message: 'Error deleting rocket', style: 'bg-danger'})
								hideLoading();
								return;
							}

							navigate('/rockets')

							showToast({
								message: 'Rocket deleted',
								style: 'bg-success'
							})
						}
					}
				]
			})
		},
		deleteFlight(flight) {
			
			commands.warmUp();

			showConfirm({
				title: 'Confirm deletion',
				message: `Are you sure you want to delete this flight?`,
				buttons: [
					{
						text: 'Cancel',
						style: 'white'
					},
					{
						text: 'Delete flight',
						style: 'danger',
						action: async () => {

							let result = await commands.rockets.flightDelete({ rocketId: this.rocket.id, flightId: flight.id })
							if(!result.success)
							{
								showToast({ message: 'Error deleting flight', style: 'bg-danger'})
								hideLoading();
								return;
							}

							showToast({
								message: 'Flight deleted',
								style: 'bg-success'
							})
						}
					}
				]
			})
		}
	}
}

</script>
<template>
	<div v-if="ready" class="container py-5">
		
		<div class="row justify-content-center">
			<div class="col-12 col-md-6 my-5">

				<h1 class="display-4 text-center mb-3">{{ this.rocket.name }}</h1>
				<p class="text-muted text-center mb-5">Log flights against this rocket.</p>
				<p class="alert alert-light mb-4"><span class="fe fe-info"></span> Looking for where to submit Certification and MAP flights? Add a new flight to get started.</p>
				<p class="text-muted text-center mb-2"><a :href="CertFlightCardUrl" target="_blank">Download the Certification/Record Attempt Flight Card <span class="fe fe-download"></span></a> for use in the field.</p>
				<p class="text-muted text-center mb-5"><a :href="MapFlightCardUrl" target="_blank">Download the MAP Flight Card <span class="fe fe-download"></span></a> for use in the field.</p>
				
				<div v-if="rocket.photoUrl">
					<img :src="rocket.photoUrl" :alt="`Photo of ${rocket.name}`" class="w-100" />
					<hr />
				</div>

				<div class="row mb-4">
					<div class="col">
						<a :href="`/rockets/${rocket.id}/edit`" class="btn btn-sm btn-outline-primary btn-block">
							Edit rocket <span class="fe fe-edit"></span>
						</a>
					</div>
					<div class="col">
						<button @click.prevent="deleteRocket()" class="btn btn-sm btn-outline-danger btn-block">
							Delete rocket <span class="fe fe-trash-2"></span>
						</button>
					</div>
				</div>
				<a :href="`/rockets/${this.rocket.id}/flights/add`" class="btn btn-primary d-block mb-4">
					Add new flight
					<span class="fe fe-plus-circle"></span>
				</a>
				<hr>
				<div v-for="flight in flights" :class="`card ${flight.outcome == 'negative' ? 'border-left-danger' : flight.outcome == 'neutral' ? 'border-left-secondary' : flight.outcome == 'positive' ? 'border-left-success' : null}`">
					<span v-if="flight.mapFlight" :class="`badge ${flight.mapStatus == 'approved' ? 'badge-success' : flight.mapStatus == 'rejected' ? 'badge-danger' : 'badge-primary'}`" style="position: absolute; top:-5px; right: -5px;">
						<span class="fe fe-award"></span>
						<span>MAP: {{ flight.mapStatus == 'approved' ? 'Approved' : flight.mapStatus == 'rejected' ? 'Rejected' : 'Pending UKRA' }}</span>
					</span>
					<span v-if="flight.certFlight" :class="`badge ${flight.certStatus == 'approved' ? 'badge-success' : flight.certStatus == 'rejected' ? 'badge-danger' : 'badge-primary'}`" style="position: absolute; top:-5px; right: -5px;">
						<span class="fe fe-award"></span>
						<span>{{ attemptTypeToFullAttempt(flight.certType) }}: {{ flight.certStatus == 'approved' ? 'Approved' : flight.certStatus == 'rejected' ? 'Rejected' : 'Pending UKRA' }}</span>
					</span>
					<span v-if="flight.recordAttempt" :class="`badge ${flight.recordStatus == 'approved' || flight.recordStatus == 'held' ? 'badge-success' : flight.recordStatus == 'rejected' ? 'badge-danger' : flight.recordStatus == 'lost' ? 'badge-secondary' : 'badge-primary'}`" style="position: absolute; top:-5px; left: -5px;">
						<span class="fe fe-award"></span>
						<span>Record: {{ flight.recordStatus == 'approved' ? 'Approved' : flight.recordStatus == 'held' ? 'Held' : flight.recordStatus == 'rejected' ? 'Rejected' : flight.recordStatus == 'lost' ? 'Lost' : 'Pending UKRA' }}</span>
					</span>
					<div class="card-body">
						<div class="row align-items-center">
							<div class="col ms-n2">
								<h4 class="mb-1">
									<a v-if="!flight.locked" :href="`/rockets/${rocket.id}/flights/${flight.id}`" class="">{{ flight.name || motorsToString(flight.motors) }}</a>
									<span v-else>{{ flight.name || motorsToString(flight.motors) }}</span>
								</h4>
								<p class="small text-muted mb-1">
									<time>{{ flight.flownOn.format('yyyy/MM/dd HH:mm') }}</time> @ <span>{{ flight.location || 'Unknown location'}}</span>
								</p>
								<p class="small text-muted mb-1" v-if="flight.motors.length && flight.name">
									{{ motorsToString(flight.motors) }} {{ flight.ejections }}
								</p>
							</div>
							<div class="col-auto">
								<a :href="`/rockets/${rocket.id}/flights/${flight.id}`" class="btn btn-sm btn-outline-primary">
									View
									<span class="fe fe-arrow-right-circle"></span>
								</a>
							</div>
							<div v-if="!flight.outcome" class="col-auto">
								<a :href="`/rockets/${rocket.id}/flights/${flight.id}/edit#outcome`" class="btn btn-sm btn-primary">
									Set outcome
								</a>
							</div>
							<div class="col-auto px-0">
								<div class="dropdown">
									<button class="btn p-0 dropdown-ellipses dropdown-toggle" aria-haspopup="true" aria-expanded="true">
										<i class="fe fe-more-vertical"></i>
									</button>
									<div class="dropdown-menu dropdown-menu-end">
										<a :href="`/rockets/${rocket.id}/flights/${flight.id}/edit`" v-if="!flight.locked" class="dropdown-item text-primary">
											<span class="fe fe-edit"></span> Edit
										</a>
										<button disabled="true" v-if="flight.locked" class="dropdown-item">
											<span class="fe fe-edit"></span> Edit
										</button>
										<button @click.prevent="deleteFlight(flight)" :disabled="flight.locked" class="dropdown-item dropdown-item-danger">
											<span class="fe fe-trash-2"></span> Delete
										</button>
									</div>
								</div>
							</div>
						</div>
						<p v-if="flight.notes" class="small mt-2">{{ flight.notes }}</p>
						<div v-for="task of flight.mapTasks" :class="`d-inline-block ${flight.mapStatus == 'rejected' ? 'grayscale' : null}`" :aria-title="task.name" :style="`background: url(${task.bg}); background-size: contain; width: 32px; height: 34px;`">
							<img :src="task.icon" style="width: 32px; height: 34px;" />
						</div>
						<template v-if="flight.logs.length">
							<hr class="mb-0">
							<div class="list-group list-group-flush">
								<div v-for="(log, index) in flight.logs" :class="`list-group-item ${index == flight.logs.length - 1 ? 'pb-0' : ''}`">
									<div class="row align-items-center small">
										<div class="col ms-n2">
											{{ log.name }}
										</div>
										<div class="col-auto">
											<a :href="`/rockets/${rocket.id}/flights/${flight.id}/logs/${log.id}`" class="btn btn-sm btn-outline-primary" type="button"><span class="fe fe-eye"></span> View</a>
										</div>
									</div>
								</div>
							</div>
						</template>
					</div>
				</div>
				<div v-if="rocket.flights.length == 0">
					<div class="card">
						<div class="card-body text-center">
							<p class="text-muted mb-0">You haven't added any flights to this rocket yet.</p>
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>
